import { formatISO9075 } from 'date-fns';
import { useEffect, useState, useContext } from 'react';
import { UserContext } from '../UserContext';
import { useParams } from 'react-router-dom';
import CustomLink from '../components/Navbar/CustomLink';

type AuthorType = {
  _id: string;
  username: string;
};

type PostInfoType = {
  _id: string;
  title: string;
  content: string;
  summary: string;
  createdAt: string;
  cover?: string;
  urlTitle?: string;
  author: AuthorType;
};

const PostPage = () => {
  const [postInfo, setPostInfo] = useState<PostInfoType | null>(null);
  const { userInfo } = useContext(UserContext);
  const { id } = useParams<{ id: string }>();
  useEffect(() => {
    // console.log(id);
    fetch(`${process.env.REACT_APP_BACKEND_URL}/post/${id}`).then((response) => {
      response.json().then((postInfo) => {
        setPostInfo(postInfo);
      });
    });
  }, [id]);
  if (!postInfo) return <div>Loading...</div>;
  // console.log(postInfo);
  console.log(userInfo, postInfo);

  return (
    <div className="center-content">
      <div className="post-page">
        <h1>{postInfo.title}</h1>
        <time>{formatISO9075(new Date(postInfo.createdAt))}</time>
        <div className="author">by @{postInfo.author.username}</div>
        {userInfo && userInfo?.id === postInfo._id && (
          <div className="edit-row">
            <CustomLink to={`/edit/${postInfo.urlTitle}`} className="edit-btn">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="w-6 h-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10"
                />
              </svg>
              Edit this post
            </CustomLink>
          </div>
        )}
        <div className="image">
          <img
            src={`https://smartpush-aws-s3-bucket.s3.eu-central-1.amazonaws.com/${postInfo.cover}`}
            alt=""
          />
        </div>
        <div className="content" dangerouslySetInnerHTML={{ __html: postInfo.content }} />
      </div>
    </div>
  );
};

export default PostPage;
